import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdminBoxQuantityHistoryReasonType } from '../../enums/admin-box-quantity-history-reason-type';
import { AdminBoxQuantityHistoryReasonTypePipe } from '../../pipes/admin-box-quantity-history-reason-type.pipe';

@Component({
  selector: 'app-admin-box-quantity-history-reason-type',
  imports: [CommonModule, AdminBoxQuantityHistoryReasonTypePipe],
  templateUrl: './admin-box-quantity-history-reason-type.component.html',
  styleUrl: './admin-box-quantity-history-reason-type.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdminBoxQuantityHistoryReasonTypeComponent {
  public readonly type = input.required<AdminBoxQuantityHistoryReasonType>();

  protected readonly cssClass = computed(() => {
    switch (this.type()) {
      case AdminBoxQuantityHistoryReasonType.NewProduct:
        return 'text-green-600';

      case AdminBoxQuantityHistoryReasonType.ByNewOrder:
        return 'text-blue-600';

      case AdminBoxQuantityHistoryReasonType.ByAddToOrderShipment:
        return 'text-zinc-600';

      case AdminBoxQuantityHistoryReasonType.ByRemoveFromOrderShipment:
        return 'text-mauve-600';

      case AdminBoxQuantityHistoryReasonType.ByCancelOrder:
        return 'text-indigo-600';

      case AdminBoxQuantityHistoryReasonType.ByRefundOrder:
        return 'text-emerald-700';

      case AdminBoxQuantityHistoryReasonType.Manual:
        return 'text-fuchsia-600';

      default:
        return '';
    }
  });
}
